import React from "react";
import "../../assets/css/notification.css";
import "../../assets/css/input.css";
import "../../assets/css/errors.css";
import {images} from "../../constant";
import CommonStaticSidebar from "./commonStaticSidebar";
import Input from 'react-phone-number-input/input'
import {DatePicker} from "antd";
import "antd/dist/antd.css";
import API from "../../api";
import * as moment from "moment";
import {Helmet} from "react-helmet";
import {BASE_URL, handleNumberType, hideAlertAfterDelay} from "../../helper";
import CustomSelect from "../Common/CustomSelect";

var Loader = require("react-loader");
const api = new API();

class Career extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            data: this.getInitialCareerData(),
            errors: {},
            touched: this.getInitialTouchedState(),
            errorAlert: null,
            disabled:false,
            states : [],
            cities :[],
            loading: true,
            employmentOptions: [
                {label: 'Cashier', value: 'Cashier'},
                {label: 'Butcher', value: 'Butcher'},
                {label: 'Meat cutter', value: 'Meat cutter'},
                {label: 'Cook', value: 'Cook'},
                {label: 'Prep cook', value: 'Prep cook'},
                {label: 'Line server', value: 'Line server'},
                {label: 'Janitor', value: 'Janitor'},
                {label: 'Kiosk host', value: 'Kiosk host'},
            ],
        };
        this.handleChange = this.handleChange.bind(this);
        this.handleBlur = this.handleBlur.bind(this);
        this.handleRecentEmployerChange = this.handleRecentEmployerChange.bind(this);
        this.handlePriorEmployerChange = this.handlePriorEmployerChange.bind(this);
        this.firstNameRef =  React.createRef();
        this.lastNameRef =  React.createRef();
        this.restaurantRef =  React.createRef();
        this.ageRef =  React.createRef();
        this.veteranRef =  React.createRef();
        this.employedRef =  React.createRef();
        this.licenseRef =  React.createRef();
        this.worldRef =  React.createRef();
        this.felonyRef =  React.createRef();
        this.alertBox =  React.createRef();
        this.dayAvailableRef =  React.createRef();
    }

    getInitialCareerData() {
        return {
            firstname : "",
            lastname : "",
            email : "",
            phone : "",
            address_1 : "",
            address_2 : "",
            city : "",
            state : "",
            restaurant_applying_for : "",
            position_applying_for : "",
            employment_type : null, // 0 Part time, 1 Full time
            existing_experience: [],
            days_available : [],
            available_start_date : "",
            hours_available : "",
            desired_hourly_pay : "",
            date_of_birth : moment('01/01/2011', "MM-DD-YYYY"),
            above_eighteen: "",
            is_veteran : "",
            is_employed : "",
            license : "",
            entitled_to_word : "",
            convicted_of_felony : "",
            release_in_twelve_month : null,
            name_of_high_school : "",
            high_school_year : null, //0 NA, 1 9th, 2 10th, 3 11th, 4 12th
            name_of_college : "",
            college_year : null, // 0 NA, 1 1 year, 2 2 year, 3 3 year, 4 4 year
            certification_in_food_manager : null, //0 No, 1 Yes
            certification_in_food_handler : null, // 0 No, 1 Yes
            trade_school_completed : null,
            other : null,
            skills: null,
            recent_employer : {
                employer_type : "", // most recent employer
                employer_name : "",
                employer_address : "",
                employer_city_state_zip : "",
                employer_phone : "",
                employer_supervisor : "",
                date_of_employment :  "",
                position : null,
                pay : null,
                may_we_contact : null // 0 NA, 1 Yes, 2 No
            },
            prior_employer : {
                employer_type : null, // most recent employer
                employer_name : "",
                employer_address : "",
                employer_city_state_zip : "",
                employer_phone : "",
                employer_supervisor : "",
                date_of_employment :  "",
                position : null,
                pay : null,
                may_we_contact : "" // 0 NA, 1 Yes, 2 No
            }
        };
    }

    getCareerFieldNames() {
        return [
            "firstname",
            "lastname",
            "restaurant_applying_for",
            "days_available",
            "above_eighteen",
            "is_veteran",
            "is_employed",
            "license",
            "entitled_to_word",
            "convicted_of_felony",
        ];
    }

    isCareerValidationField(name) {
        return this.getCareerFieldNames().includes(name);
    }

    getInitialTouchedState() {
        return this.getCareerFieldNames().reduce((touched, name) => {
            touched[name] = false;
            return touched;
        }, {});
    }

    getAllTouchedState() {
        return this.getCareerFieldNames().reduce((touched, name) => {
            touched[name] = true;
            return touched;
        }, {});
    }

    sanitizeCareerFieldValue(name, value) {
        let updatedValue = value === null || value === undefined ? "" : value.toString();

        if (name === "firstname" || name === "lastname") {
            updatedValue = updatedValue
                .replace(/[^a-zA-Z\s]/g, "")
                .replace(/\s+/g, " ")
                .slice(0, 25);
        }

        return updatedValue;
    }

    // Career validation is shared by blur, change-after-blur, and submit.
    getFieldValidationError(name, value) {
        const fieldValue = value === null || value === undefined ? "" : value.toString().trim();

        if (name === "firstname") {
            return !fieldValue ? "Enter first name" : "";
        }

        if (name === "lastname") {
            return !fieldValue ? "Enter last name" : "";
        }

        if (name === "restaurant_applying_for") {
            return !fieldValue ? "Please select restaurant applying for" : "";
        }

        if (name === "days_available") {
            return !Array.isArray(value) || value.length < 1 ? "Please select days available" : "";
        }

        if (name === "above_eighteen") {
            return !fieldValue ? "Please select age preference" : "";
        }

        if (name === "is_veteran") {
            return !fieldValue ? "Please select veteran preference" : "";
        }

        if (name === "is_employed") {
            return !fieldValue ? "Please select employed preference" : "";
        }

        if (name === "license") {
            return !fieldValue ? "Please select license preference" : "";
        }

        if (name === "entitled_to_word") {
            return !fieldValue ? "Please select work authorization preference" : "";
        }

        if (name === "convicted_of_felony") {
            return !fieldValue ? "Please select felony preference" : "";
        }

        return "";
    }

    getFormValidationErrors(data = this.state.data) {
        const errors = {};

        this.getCareerFieldNames().forEach((name) => {
            const error = this.getFieldValidationError(name, data[name]);

            if (error) {
                errors[name] = error;
            }
        });

        return errors;
    }

    getUpdatedErrors(name, value, errors = this.state.errors) {
        const updatedErrors = {...errors};
        const fieldError = this.getFieldValidationError(name, value);

        if (fieldError) {
            updatedErrors[name] = fieldError;
        } else {
            delete updatedErrors[name];
        }

        return updatedErrors;
    }

    scrollToFirstError(errors) {
        const fieldRefs = {
            firstname: this.firstNameRef,
            lastname: this.lastNameRef,
            restaurant_applying_for: this.restaurantRef,
            days_available: this.dayAvailableRef,
            above_eighteen: this.ageRef,
            is_veteran: this.veteranRef,
            is_employed: this.employedRef,
            license: this.licenseRef,
            entitled_to_word: this.worldRef,
            convicted_of_felony: this.felonyRef,
        };
        const firstErrorField = this.getCareerFieldNames().find((name) => errors[name]);

        if (firstErrorField && fieldRefs[firstErrorField] && fieldRefs[firstErrorField].current) {
            fieldRefs[firstErrorField].current.scrollIntoView({
                behavior: "smooth",
                block: "start",
            });
        }
    }

    renderFieldError(name) {
        return this.state.errors[name] ? (
            <span className="error-text mt-1 d-block">{this.state.errors[name]}</span>
        ) : null;
    }

    componentDidMount() {
        window.scrollTo(0, 0);
        api.getStates().then((states) => {
            this.setState({states: states.data.response});
        });
    }

    getStateOptions() {
        return [
            {value: "", label: "Select", disabled: true},
            ...this.state.states.map((state) => ({
                value: state?.state_name,
                label: state?.state_name,
            })),
        ];
    }

    getCityOptions() {
        return [
            {value: "", label: "Select", disabled: true},
            ...this.state.cities.map((city) => ({
                value: city?.city,
                label: city?.city,
            })),
        ];
    }

    handleChange(event) {
        const {name} = event.target;
        const value = this.sanitizeCareerFieldValue(name, event.target.value);

        this.setState((prevState) => {
            let data = {...prevState.data};

            if (name === "days_available" || name === "existing_experience") {
                const currentValues = Array.isArray(prevState.data[name]) ? prevState.data[name] : [];
                data[name] = currentValues.includes(value)
                    ? currentValues.filter((selectedValue) => selectedValue !== value)
                    : currentValues.concat(value);
            } else if (name === "state") {
                data = {
                    ...data,
                    state: value,
                    city: ""
                };
            } else {
                data[name] = value;
            }

            const shouldValidate = this.isCareerValidationField(name) &&
                (prevState.touched[name] || prevState.errors[name]);

            return {
                data,
                errors: shouldValidate
                    ? this.getUpdatedErrors(name, data[name], prevState.errors)
                    : prevState.errors,
                errorAlert: null
            };
        }, () => {
            if (name === "state") {
                api.getCitiesByState(value).then((cities) => {
                    this.setState({cities: cities.data.response});
                });
            }
        });
    }

    handleBlur(event) {
        const {name} = event.target;

        if (!this.isCareerValidationField(name)) {
            return;
        }

        const touched = {
            ...this.state.touched,
            [name]: true
        };

        this.setState({
            touched,
            errors: this.getUpdatedErrors(name, this.state.data[name])
        });
    }

    handleRecentEmployerChange(event) {
        let inputData = this.state.data.recent_employer;
        if(event.target.name === "may_we_contact_recent"){
            inputData["may_we_contact"] = event.target.value;
        }else{
            inputData[event.target.name] = event.target.value;
        }
        this.setState({recent_employer: inputData});
    }

    handlePriorEmployerChange(event) {
        let inputData = this.state.data.prior_employer;
        inputData[event.target.name] = event.target.value;
        this.setState({prior_employer: inputData});
    }

    handleSubmit(event) {

        this.setState({
            errorAlert: null,
            disabled:true
        });
        event.preventDefault();

        const errors = this.getFormValidationErrors();

        if (Object.keys(errors).length > 0) {
            this.setState({
                errors,
                touched: this.getAllTouchedState(),
                disabled: false
            });
            this.scrollToFirstError(errors);
            return false;
        }

        this.setState({loading : false});
        const data = {...this.state.data};
        const existingExperience = !!data.existing_experience.length ? data.existing_experience.join(', ') : [];
        data.existing_experience = !!existingExperience ? existingExperience : '';

        api.careerAction(data)
            .then((success) => {

                this.setState({
                    disabled:false,
                    errors: {},
                    touched: this.getInitialTouchedState(),
                    data: this.getInitialCareerData(),
                    errorAlert: "Thank you for your message. A Farmer's Fresh Team Member will get back with you shortly!",
                    loading : true,
                });

                this.alertBox.current.scrollIntoView({
                    behavior: "smooth",
                    block: "start",
                });

                // clear previous timer
                if (this.alertTimeout) {
                    clearTimeout(this.alertTimeout);
                }
            
                // start new timer
                this.alertTimeout = hideAlertAfterDelay(() => {
                    this.setState({ errorAlert: null });
                });

            })
            .catch((error) => {
                const errorMessage = error.response && error.response.data && error.response.data.message
                    ? error.response.data.message
                    : "Unable to submit application";

                this.setState({
                    loading : true,
                    disabled:false,
                    errorAlert: errorMessage,
                });

                // clear previous timer
                if (this.alertTimeout) {
                    clearTimeout(this.alertTimeout);
                }
            
                // start new timer
                this.alertTimeout = hideAlertAfterDelay(() => {
                    this.setState({ errorAlert: null });
                });
            });
    }

    render() {

        var options = {
            shadow: false,
            scale: 1.0,
            corners: 1,
            color: "#000",
            hwaccel: false,
            position: "absolute",
            direction: 1,
            speed: 1,
            trail: 60,
            fps: 20,
            top: "55%",
            left: "60%",
            zIndex: 10000,
            radius: 5,
            width: 4
        };

        return (
            <>
                <React.Fragment>
                    <Helmet>
                        <meta charSet="utf-8" />
                        <title>Farmer's Fresh Meat - Career</title>
                        <meta name="description" content="Farmer's Fresh Meat is proud to be the best butcher shop and meat market in Houston, Texas. Buy wholesale beef, goat meat, chicken, and more - on sale now!"/>
                        <meta name="robots" content="index, follow"/>
                        <meta name="googlebot" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1"/>
                        <meta property="og:type" content="article"/>
                        <meta property="og:title" content="Farmer's Fresh Meat - Voted Best Meat Market/Butcher Shop in Houston"/>
                        <meta property="og:description" content="Farmer's Fresh Meat is proud to be the best butcher shop and meat market in Houston, Texas. Buy wholesale beef, goat meat, chicken, and more - on sale now!"/>
                        <meta property="og:url" content={BASE_URL() + this.props.location.pathname}/>
                        <meta property="og:site_name" content="Farmer&#039;s Fresh Meat: Houston Meat Market &amp; Butcher Shop"/>
                        <meta property="article:publisher" content="https://www.facebook.com/farmersfreshmeat"/>
                        <meta property="article:modified_time" content="2022-02-28T13:10:39+00:00"/>
                        <meta property="og:image" content={images.logoImg}/>
                        <meta property="og:image:width" content="1449"/>
                        <meta property="og:image:height" content="1024"/>
                        <meta name="twitter:card" content="summary"/>
                        <meta name="twitter:creator" content="Farmerfreshmeat"/>
                        <meta name="twitter:site" content="Farmerfreshmeat"/>
                        <link rel="canonical" href={BASE_URL() + this.props.location.pathname}/>
                        <script type="application/ld+json" className="yoast-schema-graph">{` {"@context":"https://schema.org","@graph":[{"@type":"Organization","@id":"https://farmersfreshmeat.com/#organization","name":"Farmer's Fresh Meat","url":"https://farmersfreshmeat.com/","sameAs":["https://www.facebook.com/farmersfreshmeat","https://www.instagram.com/farmersfreshmeat/","https://www.youtube.com/user/farmersfreshmeat","https://www.pinterest.com/Farmerfreshmeat/","https://twitter.com/Farmerfreshmeat"],"logo":{"@type":"ImageObject","@id":"https://farmersfreshmeat.com/#logo","inLanguage":"en-US","url":"https://farmersfreshmeat.com/wp-content/uploads/2015/03/Farmers_Fresh_Meat_Logo.png","width":312,"height":79,"caption":"Farmer's Fresh Meat"},"image":{"@id":"https://farmersfreshmeat.com/#logo"}},{"@type":"WebSite","@id":"https://farmersfreshmeat.com/#website","url":"https://farmersfreshmeat.com/","name":"Farmer&#039;s Fresh Meat: Houston Meat Market &amp; Butcher Shop","description":"Farmers Fresh Meat","publisher":{"@id":"https://farmersfreshmeat.com/#organization"},"potentialAction":[{"@type":"SearchAction","target":"https://farmersfreshmeat.com/?s={search_term_string}","query-input":"required name=search_term_string"}],"inLanguage":"en-US"},{"@type":"ImageObject","@id":"https://farmersfreshmeat.com/shop/leg-quarters/#primaryimage","inLanguage":"en-US","url":"https://farmersfreshmeat.com/wp-content/uploads/2019/09/Leg-Quarters-3-scaled.jpg","width":1449,"height":1024},{"@type":"WebPage","@id":"https://farmersfreshmeat.com/shop/leg-quarters/#webpage","url":"https://farmersfreshmeat.com/shop/leg-quarters/","name":"Fresh Chicken Leg Quarters By the Pound - On Sale now!","isPartOf":{"@id":"https://farmersfreshmeat.com/#website"},"primaryImageOfPage":{"@id":"https://farmersfreshmeat.com/shop/leg-quarters/#primaryimage"},"datePublished":"2019-09-23T15:14:32+00:00","dateModified":"2022-02-28T13:10:39+00:00","description":"Fresh Chicken Leg Quarters on Sale and Priced per pound. Hormone free and cut free of charge. The best price and quality at Farmer's Fresh Meat!","inLanguage":"en-US","potentialAction":[{"@type":"ReadAction","target":["https://farmersfreshmeat.com/shop/leg-quarters/"]}]}]}`}</script>
                    </Helmet>

                    <div className="about-banner">
                        <div className="image-wrap">
                            <div className="img-content">
                                <img
                                    src={images.about}
                                    alt="Not Found"
                                    className="img-fluid"
                                />
                            </div>
                            <div className="overlay"></div>
                        </div>
                        <div className="banner-content">
                            <h1 >Career <span className="text-lowercase">at</span> Farmer's</h1>
                            <h5>Employment</h5>
                        </div>
                    </div>
                    <div className="container-fluid mb-fix emp-form mt-3">
                        <div className="col-12">
                            <div className="row">
                                <CommonStaticSidebar />
                                <div className="col-md-9">
                                    <div className="row justify-content-center">
                                        <div className="col-md-12 main-section bg-white mb-4">
                                            <div className="row">
                                                <div className="title pl-3 mb-3">
                                                    <h2 className="main-head">Employment</h2>
                                                    <h6 className="mt-1 text-muted">Farmer’s Fresh Meat is an equal opportunity employer and is always looking to bring on talented members to our team. Our positions in the meat department are as follows:</h6>
                                                    <ul className="list">
                                                        <li>red meat butcher,</li>
                                                        <li>meat cutter,</li>
                                                        <li>cashier,</li>
                                                        <li>cook,</li>
                                                        <li>prep cook,</li>
                                                        <li>janitor,</li>
                                                        <li>dishwasher</li>
                                                        <li>kiosk host: assist with in-store kiosk orders, promote
                                                            weekly sale text sign-ups, and guide customers on
                                                            downloading and using the Farmer's Fresh Kitchen app for
                                                            online ordering, and
                                                        </li>
                                                        <li>we also have a full-service kitchen and are always looking for talented team members with cooking and serving experience.</li>
                                                    </ul>
                                                    <h6 className="label">
                                                        Farmer’s is a fast-paced environment that values a positive attitude, with an emphasis on great customer service.
                                                    </h6>
                                                    <h6 className="label">
                                                        If you feel you have what it takes, please complete the Online Employment Application Form below or print and drop off the downloadable Employment Application Form.
                                                    </h6>
                                                </div>
                                            </div>
                                        </div>

                                        <Loader
                                            className="spinner"
                                            options={options}
                                            loaded={this.state.loading}
                                        />

                                        <div className="col-md-12 main-section bg-white">
                                            <div className="row" ref={this.alertBox}>
                                                <div className="title text-center pl-3 mb-3">
                                                    <h2 className="main-head">Application details</h2>
                                                    <h6 className="mt-0 text-muted">Please fully complete this online application form.</h6>
                                                </div>
                                                {this.state.errorAlert ? (
                                                    <div className="col-12 px-4">
                                                        <div role="alert"
                                                             className="sc-1wz9i2x-0 fooVeKSuccess align-items-start mt-1"
                                                        >
                                                            <svg viewBox="0 0 512 512" className="text-success w-16 mr-2">
                                                                <path d="M0 256C0 114.6 114.6 0 256 0C397.4 0 512 114.6 512 256C512 397.4 397.4 512 256 512C114.6 512 0 397.4 0 256zM371.8 211.8C382.7 200.9 382.7 183.1 371.8 172.2C360.9 161.3 343.1 161.3 332.2 172.2L224 280.4L179.8 236.2C168.9 225.3 151.1 225.3 140.2 236.2C129.3 247.1 129.3 264.9 140.2 275.8L204.2 339.8C215.1 350.7 232.9 350.7 243.8 339.8L371.8 211.8z"/>
                                                            </svg>
                                                            <div className="text-message">
                                                                <h6>Thank you for your message.</h6>
                                                                <p>A Farmer's Fresh Team Member will get back with you shortly!</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                ) : null}
                                                <div className="col-md-6 mb-3 fields " ref={this.firstNameRef}>
                                                    <label
                                                        htmlFor="exampleInputFirstName"
                                                        className="label mb-1"
                                                    >
                                                        First Name *
                                                    </label>
                                                    <input
                                                        type="text"
                                                        className={"form-control valid-control " + (this.state.errors.firstname ? " invalid" : "")}
                                                        name="firstname"
                                                        placeholder="Enter first name"
                                                        value={this.state.data.firstname}
                                                        onChange={(e)=>{
                                                            this.handleChange(e)
                                                        }}
                                                        onBlur={this.handleBlur}
                                                        maxLength="25"
                                                    />
                                                    {this.renderFieldError("firstname")}
                                                </div>
                                                <div className="col-md-6 mb-3 fields "  ref={this.lastNameRef}>
                                                    <label
                                                        htmlFor="exampleInputFirstName"
                                                        className="label mb-1"
                                                    >
                                                        Last Name *
                                                    </label>
                                                    <input
                                                        type="text"
                                                        className={"form-control valid-control " + (this.state.errors.lastname ? " invalid" : "")}
                                                        name="lastname"
                                                        placeholder="Enter last name"
                                                        value={this.state.data.lastname}
                                                        onChange={(e)=>{
                                                            this.handleChange(e)
                                                        }}
                                                        onBlur={this.handleBlur}
                                                        maxLength="25"
                                                    />
                                                    {this.renderFieldError("lastname")}
                                                </div>
                                                <div className="col-md-6 mb-3 fields ">
                                                    <label
                                                        htmlFor="exampleInputFirstName"
                                                        className="label mb-1"
                                                    >
                                                        Email address
                                                    </label>
                                                    <input
                                                        type="text"
                                                        className={"form-control valid-control "}
                                                        placeholder="Leave blank if not applicable."
                                                        name="email"
                                                        value={this.state.data.email}
                                                        onChange={(e)=>{
                                                            this.handleChange(e)
                                                        }}
                                                    />
                                                </div>
                                                <div className="col-md-6 mb-3 fields ">
                                                    <label
                                                        htmlFor="exampleInputFirstName"
                                                        className="label mb-1"
                                                    >
                                                        Phone number
                                                    </label>
                                                    <Input
                                                        id="phone"
                                                        country="US"
                                                        className="form-control valid-control"
                                                        value={this.state.data.phone}
                                                        maxLength={14}
                                                        placeholder="Leave blank if not applicable."
                                                        required
                                                        onChange={(e)=>{
                                                            const data = {
                                                                target : {name :"phone", value : e}
                                                            };
                                                            this.handleChange(data)
                                                        }} />
                                                </div>
                                                <div className="col-md-12 mb-3 fields ">
                                                    <label
                                                        htmlFor="exampleInputFirstName"
                                                        className="label mb-1"
                                                    >
                                                        Address line 1
                                                    </label>
                                                    <input
                                                        type="text"
                                                        className={"form-control valid-control"}
                                                        placeholder="Leave blank if not applicable."
                                                        name="address_1"
                                                        value={this.state.data.address_1}
                                                        onChange={(e)=>{
                                                            this.handleChange(e)
                                                        }}
                                                    />
                                                </div>
                                                <div className="col-md-12 mb-3 fields ">
                                                    <label
                                                        htmlFor="exampleInputFirstName"
                                                        className="label mb-1"
                                                    >
                                                        Address line 2
                                                    </label>
                                                    <input
                                                        type="text"
                                                        className={"form-control valid-control "}
                                                        placeholder="Leave blank if not applicable."
                                                        name="address_2"
                                                        value={this.state.data.address_2}
                                                        onChange={(e)=>{
                                                            this.handleChange(e)
                                                        }}
                                                    />
                                                </div>
                                                <div className="col-md-6 mb-3 fields ">
                                                    <label
                                                        htmlFor="exampleInputFirstName"
                                                        className="label mb-1"
                                                    >
                                                        State
                                                    </label>

                                                    <CustomSelect
                                                        ariaLabel="Select state"
                                                        className="form-custom-select"
                                                        name="state"
                                                        value={this.state.data.state}
                                                        options={this.getStateOptions()}
                                                        onChange={this.handleChange}
                                                    />
                                                </div>
                                                <div className="col-md-6 mb-3 fields ">
                                                    <label
                                                        htmlFor="exampleInputFirstName"
                                                        className="label mb-1"
                                                    >
                                                        City
                                                    </label>
                                                    <CustomSelect
                                                        ariaLabel="Select city"
                                                        className="form-custom-select"
                                                        name="city"
                                                        value={this.state.data.city}
                                                        options={this.getCityOptions()}
                                                        onChange={this.handleChange}
                                                    />
                                                </div>
                                                <div ref={this.restaurantRef} className={"col-md-6 mb-3 fields " + (this.state.errors.restaurant_applying_for ? "invalid" : "")} >
                                                    <label
                                                        className="label"
                                                    >
                                                        What location(s) are you applying for? *
                                                    </label>
                                                    <div className="custom-check login-check mb-1">
                                                        <label className="check ">
                                                            <input
                                                                type="radio"
                                                                name="restaurant_applying_for"
                                                                value={1}
                                                                checked={this.state.data.restaurant_applying_for === "1" }
                                                                onChange={(e)=>{
                                                                    this.handleChange(e)
                                                                }}
                                                                onBlur={this.handleBlur}
                                                            />
                                                            <span className="checkmark"></span>
                                                            8630 Cullen Blvd, Houston, TX 77051
                                                        </label>
                                                    </div>
                                                    <div className="custom-check login-check mb-1">
                                                        <label className="check ">
                                                            <input
                                                                type="radio"
                                                                checked={this.state.data.restaurant_applying_for === "2"}
                                                                name="restaurant_applying_for"
                                                                value={2}
                                                                onChange={(e)=>{
                                                                    this.handleChange(e)
                                                                }}
                                                                onBlur={this.handleBlur}
                                                            />
                                                            <span className="checkmark"></span>
                                                            9541 Mesa Dr, Houston, TX 77078
                                                        </label>
                                                    </div>
                                                    <div className="custom-check login-check">
                                                        <label className="check ">
                                                            <input
                                                                type="radio"
                                                                checked={this.state.data.restaurant_applying_for === "3"}
                                                                name="restaurant_applying_for"
                                                                value={3}
                                                                onChange={(e)=>{
                                                                    this.handleChange(e)
                                                                }}
                                                                onBlur={this.handleBlur}
                                                            />
                                                            <span className="checkmark"></span>
                                                            All of the above
                                                        </label>
                                                    </div>
                                                    {this.renderFieldError("restaurant_applying_for")}
                                                </div>
                                                <div className="col-md-6 mb-3 fields ">
                                                    <label
                                                        className="label"
                                                    >
                                                        What position are you applying for?
                                                    </label>
                                                    {this.state.employmentOptions.map((option, index) => {
                                                        const value = option.value;
                                                        return (
                                                            <div className="custom-check login-check mb-1">
                                                                <label className="check ">
                                                                    <input
                                                                        type="checkbox"
                                                                        name="existing_experience"
                                                                        value={value}
                                                                        checked={this.state.data.existing_experience.includes(value)}
                                                                        onChange={(e)=>{
                                                                            this.handleChange(e)
                                                                        }}
                                                                    />
                                                                    <span className="checkmark"></span>
                                                                    {option.label}
                                                                </label>
                                                            </div>
                                                        )
                                                    })}
                                                </div>
                                                <div className="col-md-12 mb-3 fields ">
                                                    <label className="label">
                                                        What type of employment are you seeking?
                                                    </label>
                                                    <div className="custom-check login-check mb-1">
                                                        <label className="check ">
                                                            <input
                                                                type="radio"
                                                                name="position_applying_for"
                                                                value={1}
                                                                checked={this.state.data.position_applying_for === "1"}
                                                                onChange={(e)=>{
                                                                    this.handleChange(e)
                                                                }}
                                                                onBlur={this.handleBlur}
                                                            />
                                                            <span className="checkmark"></span>
                                                            Part time
                                                        </label>
                                                    </div>
                                                    <div className="custom-check login-check mb-1">
                                                        <label className="check ">
                                                            <input
                                                                type="radio"
                                                                name="position_applying_for"
                                                                value={2}
                                                                checked={this.state.data.position_applying_for === "2"}
                                                                onChange={(e)=>{
                                                                    this.handleChange(e)
                                                                }}
                                                                onBlur={this.handleBlur}
                                                            />
                                                            <span className="checkmark"></span>
                                                            Full time
                                                        </label>
                                                    </div>
                                                </div>
                                                <div className={ "col-md-12 mb-3 fields" + (this.state.errors.days_available ? " invalid" : "") } ref={this.dayAvailableRef}>
                                                    <label
                                                        className="label"
                                                    >
                                                        What days are you available? (Check all that apply) *
                                                    </label>
                                                    <div className="custom-check login-check mb-1">
                                                        <label className="check ">
                                                            <input
                                                                type="checkbox"
                                                                name="days_available"
                                                                value={1}
                                                                checked={this.state.data.days_available.includes("1")}
                                                                onChange={(e)=>{
                                                                    this.handleChange(e)
                                                                }}
                                                                onBlur={this.handleBlur}
                                                            />
                                                            <span className="checkmark"></span>
                                                            Monday
                                                        </label>
                                                    </div>
                                                    <div className="custom-check login-check mb-1">
                                                        <label className="check ">
                                                            <input
                                                                type="checkbox"
                                                                name="days_available"
                                                                value={2}
                                                                checked={this.state.data.days_available.includes("2")}
                                                                onChange={(e)=>{
                                                                    this.handleChange(e)
                                                                }}
                                                                onBlur={this.handleBlur}
                                                            />
                                                            <span className="checkmark"></span>
                                                            Tuesday
                                                        </label>
                                                    </div>
                                                    <div className="custom-check login-check mb-1">
                                                        <label className="check ">
                                                            <input
                                                                type="checkbox"
                                                                name="days_available"
                                                                value={3}
                                                                checked={this.state.data.days_available.includes("3")}
                                                                onChange={(e)=>{
                                                                    this.handleChange(e)
                                                                }}
                                                                onBlur={this.handleBlur}
                                                            />
                                                            <span className="checkmark"></span>
                                                            Wednesday
                                                        </label>
                                                    </div>
                                                    <div className="custom-check login-check mb-1">
                                                        <label className="check ">
                                                            <input
                                                                type="checkbox"
                                                                name="days_available"
                                                                value={4}
                                                                checked={this.state.data.days_available.includes("4")}
                                                                onChange={(e)=>{
                                                                    this.handleChange(e)
                                                                }}
                                                                onBlur={this.handleBlur}
                                                            />
                                                            <span className="checkmark"></span>
                                                            Thursday
                                                        </label>
                                                    </div>
                                                    <div className="custom-check login-check mb-1">
                                                        <label className="check ">
                                                            <input
                                                                type="checkbox"
                                                                name="days_available"
                                                                value={5}
                                                                checked={this.state.data.days_available.includes("5")}
                                                                onChange={(e)=>{
                                                                    this.handleChange(e)
                                                                }}
                                                                onBlur={this.handleBlur}
                                                            />
                                                            <span className="checkmark"></span>
                                                            Friday
                                                        </label>
                                                    </div>
                                                    <div className="custom-check login-check mb-1">
                                                        <label className="check ">
                                                            <input
                                                                type="checkbox"
                                                                name="days_available"
                                                                value={6}
                                                                checked={this.state.data.days_available.includes("6")}
                                                                onChange={(e)=>{
                                                                    this.handleChange(e)
                                                                }}
                                                                onBlur={this.handleBlur}
                                                            />
                                                            <span className="checkmark"></span>
                                                            Saturday
                                                        </label>
                                                    </div>
                                                    <div className="custom-check login-check mb-1">
                                                        <label className="check ">
                                                            <input
                                                                type="checkbox"
                                                                name="days_available"
                                                                value={7}
                                                                checked={this.state.data.days_available.includes("7")}
                                                                onChange={(e)=>{
                                                                    this.handleChange(e)
                                                                }}
                                                                onBlur={this.handleBlur}
                                                            />
                                                            <span className="checkmark"></span>
                                                            Sunday
                                                        </label>
                                                    </div>
                                                    {this.renderFieldError("days_available")}
                                                </div>
                                                <div className="col-md-6 mb-3 fields ">
                                                    <label
                                                        htmlFor="exampleInputFirstName"
                                                        className="label mb-1"
                                                    >
                                                        When is your available start date?
                                                    </label>
                                                    <br/>

                                                    <DatePicker
                                                        allowEmpty={false}
                                                        allowClear={false}
                                                        format="M-D-YYYY"
                                                        className={"form-control valid-control"}
                                                        value={this.state.data.available_start_date ? moment(this.state.data.available_start_date, "MM-DD-YYYY") : "" }
                                                        disabledDate={current => {
                                                            return current && current < moment().subtract(1, "day");
                                                        }}
                                                        onChange={(date) => {
                                                            let event = {
                                                                target: {
                                                                    name: "available_start_date",
                                                                    value: moment(date, "MM-DD-YYYY").format("MM-DD-YYYY")
                                                                },
                                                            };
                                                            this.handleChange(event);
                                                        }}
                                                        getPopupContainer={(triggerNode) => {
                                                            return triggerNode.parentNode;
                                                        }}
                                                    />
                                                </div>
                                                <div className="col-md-6 mb-3 fields ">
                                                    <label
                                                        htmlFor="exampleInputFirstName"
                                                        className="label mb-1"
                                                    >
                                                        What hours are you available?
                                                    </label>
                                                    <input
                                                        type="text"
                                                        className={"form-control valid-control "}
                                                        name="hours_available"
                                                        placeholder="Enter here"
                                                        value={this.state.data.hours_available}
                                                        onChange={(e)=>{
                                                            this.handleChange(e)
                                                        }}
                                                    />
                                                </div>
                                                <div className="col-md-6 mb-3 fields ">
                                                    <label
                                                        htmlFor="exampleInputFirstName"
                                                        className="label mb-1"
                                                    >
                                                        Desired Hourly Pay Rate
                                                    </label>
                                                    <input
                                                        type="text"
                                                        className={"form-control valid-control "}
                                                        placeholder="Enter here"
                                                        name="desired_hourly_pay"
                                                        value={this.state.data.desired_hourly_pay}
                                                        onChange={(e)=>{
                                                            this.handleChange(e)
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-12 main-section bg-white">
                                            <div className="row">
                                                <div className="title pl-3 mb-3"><h2>Personal information</h2></div>
                                                <div className="col-md-6 mb-3 fields ">
                                                    <label
                                                        htmlFor="exampleInputFirstName"
                                                        className="label mb-1"
                                                    >
                                                        What is your date of birth?
                                                    </label>
                                                    <br/>

                                                    <DatePicker
                                                        allowEmpty={false}
                                                        allowClear={false}
                                                        format="M-D-YYYY"
                                                        className={"form-control valid-control"}
                                                        disabledDate={ (current) => ( current.year() > 2011 )}
                                                        value={this.state.data.date_of_birth ? moment(this.state.data.date_of_birth, "MM-DD-YYYY") : ""}
                                                        onChange={(date) => {
                                                            let event = {
                                                                target: {
                                                                    name: "date_of_birth",
                                                                    value: moment(date, "MM-DD-YYYY").format("MM-DD-YYYY")
                                                                },
                                                            };
                                                            this.handleChange(event);
                                                        }}
                                                        getPopupContainer={(triggerNode) => {
                                                            return triggerNode.parentNode;
                                                        }}
                                                    />

                                                </div>
                                                {/*<div className="col-md-6 mb-3 fields "></div>*/}
                                                <div ref={this.ageRef} className={"col-md-6 mb-3 fields " + (this.state.errors.above_eighteen ? " invalid" : "")} onBlur={this.handleBlur}>
                                                    <label
                                                        htmlFor="exampleInputFirstName"
                                                        className="label mb-1"
                                                    >
                                                        Are you eighteen (18) years or older? *
                                                    </label>
                                                    <div className="custom-check login-check mb-1">
                                                        <label className="check ">
                                                            <input
                                                                type="radio"
                                                                name="above_eighteen"
                                                                value={1}
                                                                checked={this.state.data.above_eighteen === "1"}
                                                                onChange={(e)=>{
                                                                    this.handleChange(e)
                                                                }}
                                                            />
                                                            <span className="checkmark"></span>
                                                            Yes
                                                        </label>
                                                    </div>
                                                    <div className="custom-check login-check mb-1">
                                                        <label className="check ">
                                                            <input
                                                                type="radio"
                                                                name="above_eighteen"
                                                                value={0}
                                                                checked={this.state.data.above_eighteen === "0"}
                                                                onChange={(e)=>{
                                                                    this.handleChange(e)
                                                                }}
                                                            />
                                                            <span className="checkmark"></span>
                                                            No
                                                        </label>
                                                    </div>
                                                    {this.renderFieldError("above_eighteen")}
                                                </div>
                                                <div ref={this.veteranRef} className={"col-md-6 mb-3 fields " + (this.state.errors.is_veteran ? " invalid" : "")} onBlur={this.handleBlur}>
                                                    <label
                                                        htmlFor="exampleInputFirstName"
                                                        className="label mb-1"
                                                    >
                                                        Are you a veteran? *
                                                    </label>
                                                    <div className="custom-check login-check mb-1">
                                                        <label className="check ">
                                                            <input
                                                                type="radio"
                                                                name="is_veteran"
                                                                value={1}
                                                                checked={this.state.data.is_veteran === "1"}
                                                                onChange={(e)=>{
                                                                    this.handleChange(e)
                                                                }}
                                                            />
                                                            <span className="checkmark"></span>
                                                            Yes
                                                        </label>
                                                    </div>
                                                    <div className="custom-check login-check mb-1">
                                                        <label className="check ">
                                                            <input
                                                                type="radio"
                                                                name="is_veteran"
                                                                value={0}
                                                                checked={this.state.data.is_veteran === "0"}
                                                                onChange={(e)=>{
                                                                    this.handleChange(e)
                                                                }}
                                                            />
                                                            <span className="checkmark"></span>
                                                            No
                                                        </label>
                                                    </div>
                                                    {this.renderFieldError("is_veteran")}
                                                </div>
                                                <div ref={this.employedRef} className={"col-md-6 mb-3 fields" + (this.state.errors.is_employed ? " invalid" : "")} onBlur={this.handleBlur}>
                                                    <label
                                                        htmlFor="exampleInputFirstName"
                                                        className="label mb-1"
                                                    >
                                                        Are you currently employed? *
                                                    </label>
                                                    <div className="custom-check login-check mb-1">
                                                        <label className="check ">
                                                            <input
                                                                type="radio"
                                                                name="is_employed"
                                                                value={1}
                                                                checked={this.state.data.is_employed === "1"}
                                                                onChange={(e)=>{
                                                                    this.handleChange(e)
                                                                }}
                                                            />
                                                            <span className="checkmark"></span>
                                                            Yes
                                                        </label>
                                                    </div>
                                                    <div className="custom-check login-check mb-1">
                                                        <label className="check ">
                                                            <input
                                                                type="radio"
                                                                name="is_employed"
                                                                value={0}
                                                                checked={this.state.data.is_employed === "0"}
                                                                onChange={(e)=>{
                                                                    this.handleChange(e)
                                                                }}
                                                            />
                                                            <span className="checkmark"></span>
                                                            No
                                                        </label>
                                                    </div>
                                                    {this.renderFieldError("is_employed")}
                                                </div>
                                                <div ref={this.licenseRef} className={"col-md-6 mb-3 fields " + (this.state.errors.license ? " invalid" : "")} onBlur={this.handleBlur}>
                                                    <label
                                                        htmlFor="exampleInputFirstName"
                                                        className="label mb-1"
                                                    >
                                                        Do you have a valid driver's license? *
                                                    </label>
                                                    <div className="custom-check login-check mb-1">
                                                        <label className="check ">
                                                            <input
                                                                type="radio"
                                                                name="license"
                                                                value={1}
                                                                checked={this.state.data.license === "1"}
                                                                onChange={(e)=>{
                                                                    this.handleChange(e)
                                                                }}
                                                            />
                                                            <span className="checkmark"></span>
                                                            Yes
                                                        </label>
                                                    </div>
                                                    <div className="custom-check login-check mb-1">
                                                        <label className="check ">
                                                            <input
                                                                type="radio"
                                                                name="license"
                                                                value={0}
                                                                checked={this.state.data.license === "0"}
                                                                onChange={(e)=>{
                                                                    this.handleChange(e)
                                                                }}
                                                            />
                                                            <span className="checkmark"></span>
                                                            No
                                                        </label>
                                                    </div>
                                                    {this.renderFieldError("license")}
                                                </div>
                                                <div ref={this.worldRef} className={"col-md-6 mb-3 fields " + (this.state.errors.entitled_to_word ? " invalid" : "")} onBlur={this.handleBlur}>
                                                    <label
                                                        htmlFor="exampleInputFirstName"
                                                        className="label mb-1"
                                                    >
                                                        Are you entitled to work in the United States? *
                                                    </label>
                                                    <div className="custom-check login-check mb-1">
                                                        <label className="check ">
                                                            <input
                                                                type="radio"
                                                                name="entitled_to_word"
                                                                value={1}
                                                                checked={this.state.data.entitled_to_word === "1"}
                                                                onChange={(e)=>{
                                                                    this.handleChange(e)
                                                                }}
                                                            />
                                                            <span className="checkmark"></span>
                                                            Yes
                                                        </label>
                                                    </div>
                                                    <div className="custom-check login-check mb-1">
                                                        <label className="check ">
                                                            <input
                                                                type="radio"
                                                                name="entitled_to_word"
                                                                value={0}
                                                                checked={this.state.data.entitled_to_word === "0"}
                                                                onChange={(e)=>{
                                                                    this.handleChange(e)
                                                                }}
                                                            />
                                                            <span className="checkmark"></span>
                                                            No
                                                        </label>
                                                    </div>
                                                    {this.renderFieldError("entitled_to_word")}
                                                </div>
                                                <div ref={this.felonyRef} className={"col-md-6 mb-3 fields " + (this.state.errors.convicted_of_felony ? " invalid" : "")} onBlur={this.handleBlur}>
                                                    <label
                                                        htmlFor="exampleInputFirstName"
                                                        className="label mb-1"
                                                    >
                                                        Have you been convicted of a felony? *
                                                    </label>
                                                    <div className="custom-check login-check mb-1">
                                                        <label className="check ">
                                                            <input
                                                                type="radio"
                                                                name="convicted_of_felony"
                                                                value={1}
                                                                checked={this.state.data.convicted_of_felony === "1"}
                                                                onChange={(e)=>{
                                                                    this.handleChange(e)
                                                                }}
                                                            />
                                                            <span className="checkmark"></span>
                                                            Yes
                                                        </label>
                                                    </div>
                                                    <div className="custom-check login-check mb-1">
                                                        <label className="check">
                                                            <input
                                                                type="radio"
                                                                name="convicted_of_felony"
                                                                value={0}
                                                                checked={this.state.data.convicted_of_felony === "0"}
                                                                onChange={(e)=>{
                                                                    this.handleChange(e)
                                                                }}
                                                            />
                                                            <span className="checkmark"></span>
                                                            No
                                                        </label>
                                                    </div>
                                                    {this.renderFieldError("convicted_of_felony")}
                                                </div>
                                                <div className="col-md-12 mb-3 fields ">
                                                    <label
                                                        htmlFor="exampleInputFirstName"
                                                        className="label mb-1"
                                                    >
                                                        If you have been convicted of a felony, was your release within the last twelve (12) months?
                                                    </label>
                                                    <div className="custom-check login-check mb-1">
                                                        <label className="check ">
                                                            <input
                                                                type="radio"
                                                                name="release_in_twelve_month"
                                                                value={1}
                                                                checked={this.state.data.release_in_twelve_month === "1"}
                                                                onChange={(e)=>{
                                                                    this.handleChange(e)
                                                                }}
                                                            />
                                                            <span className="checkmark"></span>
                                                            Yes
                                                        </label>
                                                    </div>
                                                    <div className="custom-check login-check mb-1">
                                                        <label className="check ">
                                                            <input
                                                                type="radio"
                                                                name="release_in_twelve_month"
                                                                value={0}
                                                                checked={this.state.data.release_in_twelve_month === "0"}
                                                                onChange={(e)=>{
                                                                    this.handleChange(e)
                                                                }}
                                                            />
                                                            <span className="checkmark"></span>
                                                            No
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-12 main-section bg-white">
                                            <div className="row">
                                                <div className="title pl-3 mb-3"><h2>Education</h2></div>
                                                <div className="col-md-12 mb-3 fields ">
                                                    <label
                                                        htmlFor="exampleInputFirstName"
                                                        className="label mb-1"
                                                    >
                                                        Name of High School
                                                    </label>
                                                    <input
                                                        type="text"
                                                        className={"form-control valid-control "}
                                                        placeholder="Enter here"
                                                        name="name_of_high_school"
                                                        value={this.state.data.name_of_high_school}
                                                        onChange={(e)=>{
                                                            this.handleChange(e)
                                                        }}
                                                    />
                                                </div>
                                                <div className="col-md-6 mb-3 fields ">
                                                    <label
                                                        htmlFor="exampleInputFirstName"
                                                        className="label mb-1"
                                                    >
                                                        High School Years Completed
                                                    </label>
                                                    <div className="custom-check login-check mb-1">
                                                        <label className="check ">
                                                            <input
                                                                type="radio"
                                                                name="high_school_year"
                                                                checked={this.state.data.high_school_year === "Not Applicable"}
                                                                value={"Not Applicable"}
                                                                onChange={(e)=>{
                                                                    this.handleChange(e)
                                                                }}
                                                            />
                                                            <span className="checkmark"></span>
                                                            Not Applicable
                                                        </label>
                                                    </div>
                                                    <div className="custom-check login-check mb-1">
                                                        <label className="check ">
                                                            <input
                                                                type="radio"
                                                                name="high_school_year"
                                                                checked={this.state.data.high_school_year === "9th"}
                                                                value={"9th"}
                                                                onChange={(e)=>{
                                                                    this.handleChange(e)
                                                                }}
                                                            />
                                                            <span className="checkmark"></span>
                                                            9th
                                                        </label>
                                                    </div>
                                                    <div className="custom-check login-check mb-1">
                                                        <label className="check ">
                                                            <input
                                                                type="radio"
                                                                name="high_school_year"
                                                                checked={this.state.data.high_school_year === "10th"}
                                                                value={"10th"}
                                                                onChange={(e)=>{
                                                                    this.handleChange(e)
                                                                }}
                                                            />
                                                            <span className="checkmark"></span>
                                                            10th
                                                        </label>
                                                    </div>
                                                    <div className="custom-check login-check mb-1">
                                                        <label className="check ">
                                                            <input
                                                                type="radio"
                                                                name="high_school_year"
                                                                checked={this.state.data.high_school_year === "11th"}
                                                                value={"11th"}
                                                                onChange={(e)=>{
                                                                    this.handleChange(e)
                                                                }}
                                                            />
                                                            <span className="checkmark"></span>
                                                            11th
                                                        </label>
                                                    </div>
                                                    <div className="custom-check login-check mb-1">
                                                        <label className="check ">
                                                            <input
                                                                type="radio"
                                                                name="high_school_year"
                                                                checked={this.state.data.high_school_year === "12th"}
                                                                value={"12th"}
                                                                onChange={(e)=>{
                                                                    this.handleChange(e)
                                                                }}
                                                            />
                                                            <span className="checkmark"></span>
                                                            12th
                                                        </label>
                                                    </div>
                                                </div>
                                                <div className="col-md-12 mb-3 fields ">
                                                    <label
                                                        htmlFor="exampleInputFirstName"
                                                        className="label mb-1"
                                                    >
                                                        Name of College/University
                                                    </label>
                                                    <input
                                                        type="text"
                                                        className={"form-control valid-control "}
                                                        placeholder="Enter here"
                                                        name="name_of_college"
                                                        value={this.state.data.name_of_college}
                                                        onChange={(e)=>{
                                                            this.handleChange(e)
                                                        }}
                                                    />
                                                </div>
                                                <div className="col-md-6 mb-3 fields ">
                                                    <label
                                                        htmlFor="exampleInputFirstName"
                                                        className="label mb-1"
                                                    >
                                                        Years of College/University Completed
                                                    </label>
                                                    <div className="custom-check login-check mb-1">
                                                        <label className="check ">
                                                            <input
                                                                type="radio"
                                                                name="college_year"
                                                                checked={this.state.data.college_year === "Not Applicable"}
                                                                value={"Not Applicable"}
                                                                onChange={(e)=>{
                                                                    this.handleChange(e)
                                                                }}
                                                            />
                                                            <span className="checkmark"></span>
                                                            Not Applicable
                                                        </label>
                                                    </div>
                                                    <div className="custom-check login-check mb-1">
                                                        <label className="check ">
                                                            <input
                                                                type="radio"
                                                                name="college_year"
                                                                checked={this.state.data.college_year === "1"}
                                                                value={1}
                                                                onChange={(e)=>{
                                                                    this.handleChange(e)
                                                                }}
                                                            />
                                                            <span className="checkmark"></span>
                                                            1
                                                        </label>
                                                    </div>
                                                    <div className="custom-check login-check mb-1">
                                                        <label className="check ">
                                                            <input
                                                                type="radio"
                                                                name="college_year"
                                                                checked={this.state.data.college_year === "2"}
                                                                value={2}
                                                                onChange={(e)=>{
                                                                    this.handleChange(e)
                                                                }}
                                                            />
                                                            <span className="checkmark"></span>
                                                            2
                                                        </label>
                                                    </div>
                                                    <div className="custom-check login-check mb-1">
                                                        <label className="check ">
                                                            <input
                                                                type="radio"
                                                                name="college_year"
                                                                checked={this.state.data.college_year === "3"}
                                                                value={3}
                                                                onChange={(e)=>{
                                                                    this.handleChange(e)
                                                                }}
                                                            />
                                                            <span className="checkmark"></span>
                                                            3
                                                        </label>
                                                    </div>
                                                    <div className="custom-check login-check mb-1">
                                                        <label className="check ">
                                                            <input
                                                                type="radio"
                                                                name="college_year"
                                                                checked={this.state.data.college_year === "4"}
                                                                value={4}
                                                                onChange={(e)=>{
                                                                    this.handleChange(e)
                                                                }}
                                                            />
                                                            <span className="checkmark"></span>
                                                            4
                                                        </label>
                                                    </div>
                                                    <div className="custom-check login-check mb-1">
                                                        <label className="check ">
                                                            <input
                                                                type="radio"
                                                                name="college_year"
                                                                checked={this.state.data.college_year === "4+"}
                                                                value={"4+"}
                                                                onChange={(e)=>{
                                                                    this.handleChange(e)
                                                                }}
                                                            />
                                                            <span className="checkmark"></span>
                                                            4+
                                                        </label>
                                                    </div>
                                                </div>
                                                <div className="col-md-12 mb-3 fields ">
                                                    <label
                                                        htmlFor="exampleInputFirstName"
                                                        className="label mb-1"
                                                    >
                                                        Certification
                                                    </label>
                                                    <div className="custom-check login-check mb-1">
                                                        <label className="check ">
                                                            <input
                                                                type="checkbox"
                                                                name="certification_in_food_manager"
                                                                checked={this.state.data.certification_in_food_manager}
                                                                onChange={(e)=>{
                                                                    this.handleChange(e)
                                                                }}
                                                            />
                                                            <span className="checkmark"></span>
                                                            Food Safety Manager
                                                        </label>
                                                    </div>
                                                    <div className="custom-check login-check mb-1">
                                                        <label className="check ">
                                                            <input
                                                                type="checkbox"
                                                                name="certification_in_food_handler"
                                                                checked={this.state.data.certification_in_food_handler}
                                                                onChange={(e)=>{
                                                                    this.handleChange(e)
                                                                }}
                                                            />
                                                            <span className="checkmark"></span>
                                                            Food Safety Handler
                                                        </label>
                                                    </div>
                                                </div>
                                                <div className="col-md-6 mb-3 fields ">
                                                    <label
                                                        htmlFor="exampleInputFirstName"
                                                        className="label mb-1"
                                                    >
                                                        Trade School Completed
                                                    </label>
                                                    <input
                                                        type="text"
                                                        className={"form-control valid-control "}
                                                        placeholder="Leave blank if not applicable."
                                                        name="trade_school_completed"
                                                        value={this.state.data.trade_school_completed}
                                                        onChange={(e)=>{
                                                            this.handleChange(e)
                                                        }}
                                                    />
                                                </div>
                                                <div className="col-md-6 mb-3 fields ">
                                                    <label
                                                        htmlFor="exampleInputFirstName"
                                                        className="label mb-1"
                                                    >
                                                        Other
                                                    </label>
                                                    <input
                                                        type="text"
                                                        className={"form-control valid-control "}
                                                        placeholder="Leave blank if not applicable."
                                                        name="other"
                                                        value={this.state.data.other}
                                                        onChange={(e)=>{
                                                            this.handleChange(e)
                                                        }}
                                                    />
                                                </div>
                                                <div className="col-md-12 mb-3 fields ">
                                                    <label
                                                        htmlFor="exampleInputFirstName"
                                                        className="label mb-1"
                                                    >
                                                        List any applicable special skills, training, certificates or qualifications.
                                                    </label>
                                                    <input
                                                        type="text"
                                                        className={"form-control valid-control "}
                                                        placeholder="Enter here"
                                                        name="skills"
                                                        value={this.state.data.skills}
                                                        onChange={(e)=>{
                                                            this.handleChange(e)
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-12 main-section bg-white">
                                            <div className="row">
                                                <div className="title pl-3 mb-3">
                                                    <h2>Work Experience - Current or Most Recent Employer</h2>
                                                </div>
                                                <div className="col-md-12 mb-3 fields ">
                                                    <label
                                                        htmlFor="exampleInputFirstName"
                                                        className="label mb-1"
                                                    >
                                                        Current or Most Recent Employer
                                                    </label>
                                                    <input
                                                        type="text"
                                                        className={"form-control valid-control "}
                                                        placeholder="Leave blank if not applicable."
                                                        name="employer_name"
                                                        value={this.state.data.recent_employer.employer_name}
                                                        onChange={(e)=>{
                                                            this.handleRecentEmployerChange(e)
                                                        }}
                                                    />
                                                </div>
                                                <div className="col-md-12 mb-3 fields ">
                                                    <label
                                                        htmlFor="exampleInputFirstName"
                                                        className="label mb-1"
                                                    >
                                                        Address
                                                    </label>
                                                    <input
                                                        type="text"
                                                        className={"form-control valid-control "}
                                                        placeholder="Leave blank if not applicable."
                                                        name="employer_address"
                                                        value={this.state.data.recent_employer.employer_address}
                                                        onChange={(e)=>{
                                                            this.handleRecentEmployerChange(e)
                                                        }}
                                                    />
                                                </div>
                                                <div className="col-md-6 mb-3 fields ">
                                                    <label
                                                        htmlFor="exampleInputFirstName"
                                                        className="label mb-1"
                                                    >
                                                        City, State, and Zip
                                                    </label>
                                                    <input
                                                        type="text"
                                                        className={"form-control valid-control "}
                                                        placeholder="Leave blank if not applicable."
                                                        name="employer_city_state_zip"
                                                        value={this.state.data.recent_employer.employer_city_state_zip}
                                                        onChange={(e)=>{
                                                            this.handleRecentEmployerChange(e)
                                                        }}
                                                    />
                                                </div>
                                                <div className="col-md-6 mb-3 fields ">
                                                    <label
                                                        htmlFor="exampleInputFirstName"
                                                        className="label mb-1"
                                                    >
                                                        Phone
                                                    </label>
                                                    <Input
                                                        country="US"
                                                        className="form-control valid-control"
                                                        value={this.state.data.recent_employer.employer_phone}
                                                        maxLength={14}
                                                        placeholder="Leave blank if not applicable."
                                                        required
                                                        onChange={(e)=>{
                                                            const data = {
                                                                target : {name :"employer_phone", value : e}
                                                            };
                                                            this.handleRecentEmployerChange(data)
                                                        }} />
                                                </div>
                                                <div className="col-md-6 mb-3 fields ">
                                                    <label
                                                        htmlFor="exampleInputFirstName"
                                                        className="label mb-1"
                                                    >
                                                        Name of Immediate Supervisor
                                                    </label>
                                                    <input
                                                        type="text"
                                                        className={"form-control valid-control "}
                                                        placeholder="Leave blank if not applicable."
                                                        name="employer_supervisor"
                                                        value={this.state.data.recent_employer.employer_supervisor}
                                                        onChange={(e)=>{
                                                            this.handleRecentEmployerChange(e)
                                                        }}
                                                    />
                                                </div>
                                                <div className="col-md-6 mb-3 fields ">
                                                    <label
                                                        htmlFor="exampleInputFirstName"
                                                        className="label mb-1"
                                                    >
                                                        Dates of Employment
                                                    </label>
                                                    <br/>
                                                    <DatePicker
                                                        placeholder="select date"
                                                        allowEmpty={false}
                                                        allowClear={false}
                                                        format="M-D-YYYY"
                                                        className={"form-control valid-control"}
                                                        value={this.state.data.recent_employer.date_of_employment ? moment(this.state.data.recent_employer.date_of_employment, "MM-DD-YYYY") : ""}
                                                        onChange={(date) => {
                                                            let event = {
                                                                target: {
                                                                    name: "date_of_employment",
                                                                    value: moment(date, "MM-DD-YYYY").format("MM-DD-YYYY")
                                                                },
                                                            };
                                                            this.handleRecentEmployerChange(event);
                                                        }}
                                                        getPopupContainer={(triggerNode) => {
                                                            return triggerNode.parentNode;
                                                        }}
                                                    />
                                                </div>
                                                <div className="col-md-6 mb-3 fields ">
                                                    <label
                                                        htmlFor="exampleInputFirstName"
                                                        className="label mb-1"
                                                    >
                                                        Position
                                                    </label>
                                                    <input
                                                        type="text"
                                                        className={"form-control valid-control "}
                                                        placeholder="Leave blank if not applicable."
                                                        name="position"
                                                        value={this.state.data.recent_employer.position}
                                                        onChange={(e)=>{
                                                            this.handleRecentEmployerChange(e)
                                                        }}
                                                    />
                                                </div>
                                                <div className="col-md-6 mb-3 fields ">
                                                    <label
                                                        htmlFor="exampleInputFirstName"
                                                        className="label mb-1"
                                                    >
                                                        Pay
                                                    </label>
                                                    <input
                                                        type="text"
                                                        className={"form-control valid-control "}
                                                        placeholder="Leave blank if not applicable."
                                                        name="pay"
                                                        maxLength={10}
                                                        onKeyPress={(e)=> handleNumberType(e)}
                                                        value={this.state.data.recent_employer.pay}
                                                        onChange={(e)=>{
                                                            this.handleRecentEmployerChange(e)
                                                        }}
                                                    />
                                                </div>
                                                <div className="col-md-6 mb-3 fields ">
                                                    <label
                                                        htmlFor="exampleInputFirstName"
                                                        className="label mb-1"
                                                    >
                                                        May we Contact
                                                    </label>
                                                    <div className="custom-check login-check mb-1">
                                                        <label htmlFor="recent_employer_pay" className="check ">
                                                            <input
                                                                id="recent_employer_pay"
                                                                type="radio"
                                                                name="may_we_contact_recent"
                                                                value={0}
                                                                checked={this.state.data.recent_employer.may_we_contact === "0"}
                                                                onChange={(e)=>{
                                                                    this.handleRecentEmployerChange(e)
                                                                }}
                                                            />
                                                            <span className="checkmark"></span>
                                                            Not Applicable
                                                        </label>
                                                    </div>
                                                    <div className="custom-check login-check mb-1">
                                                        <label htmlFor="recent_employer_yes" className="check ">
                                                            <input
                                                                id="recent_employer_yes"
                                                                type="radio"
                                                                name="may_we_contact_recent"
                                                                value={1}
                                                                checked={this.state.data.recent_employer.may_we_contact === "1"}
                                                                onChange={(e)=>{
                                                                    this.handleRecentEmployerChange(e)
                                                                }}
                                                            />
                                                            <span className="checkmark"></span>
                                                            Yes
                                                        </label>
                                                    </div>
                                                    <div className="custom-check login-check mb-1">
                                                        <label  htmlFor="recent_employer_no" className="check ">
                                                            <input
                                                                id="recent_employer_no"
                                                                type="radio"
                                                                name="may_we_contact_recent"
                                                                value={2}
                                                                checked={this.state.data.recent_employer.may_we_contact === "2"}
                                                                onChange={(e)=>{
                                                                    this.handleRecentEmployerChange(e)
                                                                }}
                                                            />
                                                            <span className="checkmark"></span>
                                                            No
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-12 main-section bg-white">
                                            <div className="row">
                                                <div className="title pl-3 mb-3">
                                                    <h2>Work Experience - Prior Employer</h2>
                                                </div>
                                                <div className="col-md-12 mb-3 fields ">
                                                    <label
                                                        htmlFor="exampleInputFirstName"
                                                        className="label mb-1"
                                                    >
                                                        Current or Most Recent Employer
                                                    </label>
                                                    <input
                                                        type="text"
                                                        className={"form-control valid-control "}
                                                        placeholder="Leave blank if not applicable."
                                                        name="employer_name"
                                                        value={this.state.data.prior_employer.employer_name}
                                                        onChange={(e)=>{
                                                            this.handlePriorEmployerChange(e)
                                                        }}
                                                    />
                                                </div>
                                                <div className="col-md-12 mb-3 fields ">
                                                    <label
                                                        htmlFor="exampleInputFirstName"
                                                        className="label mb-1"
                                                    >
                                                        Address
                                                    </label>
                                                    <input
                                                        type="text"
                                                        className={"form-control valid-control "}
                                                        placeholder="Leave blank if not applicable."
                                                        name="employer_address"
                                                        value={this.state.data.prior_employer.employer_address}
                                                        onChange={(e)=>{
                                                            this.handlePriorEmployerChange(e)
                                                        }}
                                                    />
                                                </div>
                                                <div className="col-md-6 mb-3 fields ">
                                                    <label
                                                        htmlFor="exampleInputFirstName"
                                                        className="label mb-1"
                                                    >
                                                        City, State, and Zip
                                                    </label>
                                                    <input
                                                        type="text"
                                                        className={"form-control valid-control "}
                                                        placeholder="Leave blank if not applicable."
                                                        name="employer_city_state_zip"
                                                        value={this.state.data.prior_employer.employer_city_state_zip}
                                                        onChange={(e)=>{
                                                            this.handlePriorEmployerChange(e)
                                                        }}
                                                    />
                                                </div>
                                                <div className="col-md-6 mb-3 fields ">
                                                    <label
                                                        htmlFor="exampleInputFirstName"
                                                        className="label mb-1"
                                                    >
                                                        Phone
                                                    </label>
                                                    <Input
                                                        country="US"
                                                        className="form-control valid-control"
                                                        value={this.state.data.prior_employer.employer_phone}
                                                        maxLength={14}
                                                        placeholder="Leave blank if not applicable."
                                                        required
                                                        onChange={(e)=>{
                                                            const data = {
                                                                target : {name :"employer_phone", value : e}
                                                            };
                                                            this.handlePriorEmployerChange(data)
                                                        }} />
                                                </div>
                                                <div className="col-md-6 mb-3 fields ">
                                                    <label
                                                        htmlFor="exampleInputFirstName"
                                                        className="label mb-1"
                                                    >
                                                        Name of Immediate Supervisor
                                                    </label>
                                                    <input
                                                        type="text"
                                                        className={"form-control valid-control "}
                                                        placeholder="Leave blank if not applicable."
                                                        name="employer_supervisor"
                                                        value={this.state.data.prior_employer.employer_supervisor}
                                                        onChange={(e)=>{
                                                            this.handlePriorEmployerChange(e)
                                                        }}
                                                    />
                                                </div>
                                                <div className="col-md-6 mb-3 fields ">
                                                    <label
                                                        htmlFor="exampleInputFirstName"
                                                        className="label mb-1"
                                                    >
                                                        Dates of Employment
                                                    </label>

                                                    <DatePicker
                                                        placeholder="select date"
                                                        allowEmpty={false}
                                                        allowClear={false}
                                                        format="M-D-YYYY"
                                                        className={"form-control valid-control"}
                                                        value={this.state.data.prior_employer.date_of_employment ? moment(this.state.data.prior_employer.date_of_employment, "MM-DD-YYYY") : ""}
                                                        onChange={(date) => {
                                                            let event = {
                                                                target: {
                                                                    name: "date_of_employment",
                                                                    value: moment(date, "MM-DD-YYYY").format("MM-DD-YYYY")
                                                                },
                                                            };
                                                            this.handlePriorEmployerChange(event);
                                                        }}
                                                        getPopupContainer={(triggerNode) => {
                                                            return triggerNode.parentNode;
                                                        }}
                                                    />
                                                </div>
                                                <div className="col-md-6 mb-3 fields ">
                                                    <label
                                                        htmlFor="exampleInputFirstName"
                                                        className="label mb-1"
                                                    >
                                                        Position
                                                    </label>
                                                    <input
                                                        type="text"
                                                        className={"form-control valid-control "}
                                                        placeholder="Leave blank if not applicable."
                                                        name="position"
                                                        value={this.state.data.prior_employer.position}
                                                        onChange={(e)=>{
                                                            this.handlePriorEmployerChange(e)
                                                        }}
                                                    />
                                                </div>
                                                <div className="col-md-6 mb-3 fields ">
                                                    <label
                                                        htmlFor="exampleInputFirstName"
                                                        className="label mb-1"
                                                    >
                                                        Pay
                                                    </label>
                                                    <input
                                                        type="text"
                                                        className={"form-control valid-control "}
                                                        placeholder="Leave blank if not applicable."
                                                        name="pay"
                                                        maxLength={10}
                                                        onKeyPress={(e)=> handleNumberType(e)}
                                                        value={this.state.data.prior_employer.pay}
                                                        onChange={(e)=>{
                                                            this.handlePriorEmployerChange(e)
                                                        }}
                                                    />
                                                </div>
                                                <div className="col-md-6 mb-3 fields ">
                                                    <label
                                                        htmlFor="exampleInputFirstName1"
                                                        className="label mb-1"
                                                    >
                                                        May we Contact
                                                    </label>
                                                    <div className="custom-check login-check mb-1">
                                                        <label className="check ">
                                                            <input
                                                                type="radio"
                                                                name="may_we_contact"
                                                                value={0}
                                                                checked={this.state.data.prior_employer.may_we_contact === "0"}
                                                                onChange={(e)=>{
                                                                    this.handlePriorEmployerChange(e)
                                                                }}
                                                            />
                                                            <span className="checkmark"></span>
                                                            Not Applicable
                                                        </label>
                                                    </div>
                                                    <div className="custom-check login-check mb-1">
                                                        <label className="check ">
                                                            <input
                                                                type="radio"
                                                                name="may_we_contact"
                                                                value={1}
                                                                checked={this.state.data.prior_employer.may_we_contact === "1"}
                                                                onChange={(e)=>{
                                                                    this.handlePriorEmployerChange(e)
                                                                }}
                                                            />
                                                            <span className="checkmark"></span>
                                                            Yes
                                                        </label>
                                                    </div>
                                                    <div className="custom-check login-check mb-1">
                                                        <label className="check ">
                                                            <input
                                                                type="radio"
                                                                name="may_we_contact"
                                                                value={2}
                                                                checked={this.state.data.prior_employer.may_we_contact === "2"}
                                                                onChange={(e)=>{
                                                                    this.handlePriorEmployerChange(e)
                                                                }}
                                                            />
                                                            <span className="checkmark"></span>
                                                            No
                                                        </label>
                                                    </div>
                                                </div>

                                                <div className="col-md-12 fields  px-3">
                                                    <label className="label">
                                                        By submitting this application, I hereby certify that the above information, to the best of my knowledge, is correct. I understand that falsification of this information may prevent me from being hired or lead to my dismissal if hired. I also provide consent for former employers to be contacted regarding work records.</label>
                                                    <button className="btn btn-order py-2 px-4" disabled={this.state.disabled}
                                                            onClick={(e) => this.handleSubmit(e)} >Submit application</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </React.Fragment>
            </>
        );
    }
}

export default Career;
